import {Component, OnInit} from "@angular/core";
import {Translations} from "@translations";

@Component({
	selector: "sim-settings-page-stage-designer",
	templateUrl: "./settings-page-stage-designer.component.html",
	styleUrls: ["./settings-page-stage-designer.component.scss"],
	standalone: false,
})
export class SettingsPageStageDesignerComponent implements OnInit {
	T = Translations;

	constructor() {}

	ngOnInit(): void {}
}
